var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content d-flex"},[_c('section',{staticClass:"side-nav"},[_c('router-link',{attrs:{"to":{name:'Partners'}}},[_vm._v("Manage partners")]),_c('router-link',{attrs:{"to":{name:'Partners New'}}},[_vm._v("Add new partner")])],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main"},[_c('h1',[_vm._v("Add new partner")])])
}]

export { render, staticRenderFns }